class Header {
  constructor() {
    this.stickyHeader();
    this.navigation();
  }

  navigation = () => {
    const toggleBtn = document.querySelector(".js-hamburger");
    const header = document.querySelector(".js-header");
    const nav = document.querySelector(".mobile_wrapper");

    // Mobile menu toggle
    toggleBtn.addEventListener("click", (e) => {
      header.classList.toggle("open");
      nav.classList.toggle("mobile_wrapper--open");
      document.body.classList.toggle("stop-scroll");
    });

    // Handle submenu toggles for mobile
    this.initSubmenuToggles();

    // Handle null pointer links
    const parents = document.querySelectorAll(".menu-item-has-children");
    parents.forEach((parent) => {
      let link = parent.querySelector("a");
      if (link && link.getAttribute("href")?.startsWith("#")) {
        link.classList.add("null-pointer");
      }
    });
  };

  initSubmenuToggles = () => {
    const menuItemsWithChildren = document.querySelectorAll(".menu-item-has-children");

    menuItemsWithChildren.forEach((item) => {
      const link = item.querySelector("a");
      const submenu = item.querySelector(".sub-menu");
      const arrow = item.querySelector(".menu-arrow");

      if (link && submenu && arrow) {
        // Toggle submenu on arrow click
        arrow.addEventListener("click", (e) => {
          e.preventDefault();
          e.stopPropagation();

          // Close other open submenus at the same level and reset their arrows
          const currentLevel = this.getSubmenuLevel(submenu);
          const otherOpenSubmenus = document.querySelectorAll(".sub-menu.open");

          otherOpenSubmenus.forEach((otherSubmenu) => {
            if (otherSubmenu !== submenu && this.getSubmenuLevel(otherSubmenu) === currentLevel) {
              otherSubmenu.classList.remove("open");
              otherSubmenu.closest(".menu-item-has-children").classList.remove("submenu-open");
              // Reset arrow rotation for closed submenus
              const otherArrow = otherSubmenu
                .closest(".menu-item-has-children")
                .querySelector(".menu-arrow");
              if (otherArrow) {
                otherArrow.style.transform = "rotate(0deg)";
              }
            }
          });

          // Toggle current submenu
          submenu.classList.toggle("open");
          item.classList.toggle("submenu-open");

          // Rotate arrow
          arrow.style.transform = submenu.classList.contains("open")
            ? "rotate(180deg)"
            : "rotate(0deg)";
        });

        // Close submenu when clicking outside
        document.addEventListener("click", (e) => {
          if (!item.contains(e.target)) {
            submenu.classList.remove("open");
            item.classList.remove("submenu-open");
            arrow.style.transform = "rotate(0deg)";
          }
        });
      }
    });
  };

  // Helper method to determine submenu level (0 = top level, 1 = first nested, etc.)
  getSubmenuLevel = (submenu) => {
    let level = 0;
    let parent = submenu.parentElement;

    while (parent && parent.classList.contains("menu-item-has-children")) {
      level++;
      parent = parent.parentElement.closest(".menu-item-has-children");
    }

    return level;
  };

  stickyHeader = () => {
    const header = document.querySelector(".js-header");
    let prevPosY = window.scrollY;
    if (window.scrollY > 10) {
      header.classList.add("not-top");
    }

    addEventListener("scroll", () => {
      const posY = window.scrollY;
      if (posY < 10) {
        header.classList.remove("not-top");
      } else {
        header.classList.add("not-top");
      }
      if (posY <= prevPosY || posY <= 0) {
        header.classList.remove("hide");
      } else {
        header.classList.add("hide");
      }
      prevPosY = posY;
    });
  };
}
new Header();
